module.exports = __webpack_public_path__ + "static/media/banner-euro-2024.ab548f99.webp";